import React, { useContext, useMemo } from 'react';

import { Breadcrumb } from 'antd';
import styled from 'styled-components';

import { CommunityInfoContext } from './CommunityInfoContext';
import ParentCommunitySelector from '../../common/Community/ParentCommunitySelector';
import { useAppSelector } from '../../store/hook';

const StyledBreadcrumb = styled(Breadcrumb)`
  span {
    color: var(--text-primary);
  }

  li {
    display: flex;
    align-items: center;
  }
`;

const CompetitorHeaderBreadcrumbs = () => {
  const { selectedParentCommunity } = useAppSelector((state) => state.global);
  const { communityInfo, isCompetitor } = useContext(CommunityInfoContext);

  return (
    <StyledBreadcrumb
      data-test-id="cd-community-info-breadcrumbs"
      items={
        isCompetitor && selectedParentCommunity
          ? [
              {
                title: communityInfo?.comunity_name,
              },
              {
                title: <ParentCommunitySelector />,
              },
            ]
          : [
              {
                title: communityInfo?.comunity_name,
              },
            ]
      }
      separator="·"
    />
  );
};

export default CompetitorHeaderBreadcrumbs;
